import Phaser from 'phaser';

export type TextStyle = 'damage' | 'gold' | 'heal' | 'error';

export class FloatingTextManager {
    private scene: Phaser.Scene;
    private pool: Phaser.GameObjects.Text[] = [];

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }

    spawn(x: number, y: number, text: string, style: TextStyle = 'damage'): void {
        const showDamage = localStorage.getItem('setting_show_damage') !== 'false';
        const showGold = localStorage.getItem('setting_show_gold') !== 'false';

        if ((style === 'damage' || style === 'error') && !showDamage) return;
        if (style === 'gold' && !showGold) return;

        let txt = this.pool.pop();
        if (!txt) {
            txt = this.scene.add.text(0, 0, '', {
                fontFamily: 'Arial, sans-serif',
                stroke: '#000000',
                strokeThickness: 2,
            }).setOrigin(0.5).setDepth(2000);
        }

        txt.setPosition(x, y).setText(text).setVisible(true).setAlpha(1).setScale(1);

        // Style config
        let color = '#ffffff';
        let fontSize = '16px';
        let moveY = -30;
        let duration = 800;

        switch (style) {
            case 'damage':
                color = '#ffffff';
                break;
            case 'gold':
                color = '#ffd700';
                fontSize = '14px';
                moveY = -40;
                break;
            case 'heal':
                color = '#44cc44';
                break;
            case 'error':
                color = '#ff6666';
                fontSize = '14px';
                moveY = -20;
                duration = 500;
                break;
        }

        txt.setColor(color).setFontSize(fontSize);

        this.scene.tweens.add({
            targets: txt,
            y: y + moveY,
            alpha: 0,
            scale: 1,
            duration: duration,
            ease: 'Power1',
            onComplete: () => {
                txt!.setVisible(false);
                this.pool.push(txt!);
            }
        });
    }
}
